/**
 * Metadados das relações: como chamá-las na tela.
 *
 * Irmão de `campos.ts`, e pela mesma razão. A API nomeia a relação para
 * mensagem de erro — "esquemas da turma", "professores da oferta" —, e isso
 * soa burocrático como cabeçalho. Onde a frase melhora, ela é dita aqui; onde
 * não, a da API serve.
 *
 * Fica num `.ts` e não dentro do componente porque `test/campos.test.ts`
 * confere que toda relação tem título e que nenhum título sobrou de uma
 * relação que deixou de existir — e teste de Node não lê JSX.
 */

/** Título do bloco, por molde de rota. */
export const TITULO: Record<string, string> = {
  'turmas/:id/esquemas': 'Horários que esta turma segue',
  'ofertas/:id/professores': 'Quem dá esta aula',
  'ofertas/:id/locais': 'Onde esta aula pode acontecer',
  'areas/:id/limites': 'Teto diário desta área, por turma',
  'professores/:id/limites-serie': 'Teto diário por série',
  'trilhas/:id/turmas': 'Turmas de origem',
  'coincidencias/:id/ofertas': 'Aulas que caem no mesmo horário',
  'atribuicoes/:id/ofertas': 'Turmas que o grupo distribui',
  'atribuicoes/:id/cotas': 'Quem pode levar, e quantas',
  'jornadas/:id/intrajornadas': 'Intervalo entre turnos do mesmo dia',
}

/** Uma frase abaixo do título, onde a regra não é óbvia pelo nome. */
export const NOTA: Record<string, string> = {
  'ofertas/:id/professores':
    'Dois nomes aqui são co-docência: a MESMA aula com dois professores, e não duas aulas.',
  'ofertas/:id/locais': 'Vazio significa qualquer lugar, e não nenhum lugar.',
  'trilhas/:id/turmas':
    'Enquanto a aula de trilha roda, nenhuma destas turmas pode ter aula regular.',
  'coincidencias/:id/ofertas': 'Precisa de ao menos duas; com uma só, o grupo é ignorado.',
}

/** Rótulo em português para os campos próprios das relações. */
const ROTULO_CAMPO: Record<string, string> = {
  max_aulas_dia: 'Máximo de aulas por dia',
  serie: 'Série',
  duracao_min_minima: 'Descanso mínimo (min)',
  janela_inicio: 'A partir de',
  janela_fim: 'Até',
  minimo: 'Mínimo',
  maximo: 'Máximo',
}

export const rotuloDoCampo = (nome: string) =>
  ROTULO_CAMPO[nome] ?? nome.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase())

/** `turmas/:id/esquemas` → `Esquemas`, quando não há título melhor. */
export const rotuloDoBloco = (caminho: string) =>
  TITULO[caminho] ??
  (caminho.split('/').pop() ?? caminho).replace(/^./, (c) => c.toUpperCase())
